import React, { useState, useEffect } from 'react';

// Services
import { getCountries } from 'services/requests';

// Components
import SelectMultiple from 'components/select-multiple';

// ---------------------------------------------------------------------------------------------- \\
// -------------------------------------- SELECT COUNTRIES -------------------------------------- \\
// ---------------------------------------------------------------------------------------------- \\

const SelectCountries = ({ countries, setCountries }) => {
    const [options, setOptions] = useState([]);

    useEffect(() => {
        getCountries().then(res => {
            if (res.status === 200) {
                setOptions(res.data.data.countries.map(c => ({ label: c.name, value: c.id })));
            }
            else {
                console.log(res);
            }
        });
    }, []);

    return (
        <SelectMultiple
            value={countries}
            onChange={value => setCountries(value)}
            options={options}
            placeholder="Pays"
        />
    );
};

export default SelectCountries;
